/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsSignUpRequest
 */
export interface RevisdomAPIViewModelsSignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    role?: RevisdomAPIViewModelsSignUpRequestRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsSignUpRequest
     */
    notificationToEmail?: boolean;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsSignUpRequestRoleEnum = {
    AccountManager0: 'Account Manager (0)',
    AccountOwner1: 'Account Owner (1)',
    InternalTeam2: 'Internal Team (2)',
    BrandAccountViewer3: 'Brand Account Viewer (3)',
    SperYnetici4: 'Süper Yönetici (4)',
    Guest5: 'Guest (5)'
} as const;
export type RevisdomAPIViewModelsSignUpRequestRoleEnum = typeof RevisdomAPIViewModelsSignUpRequestRoleEnum[keyof typeof RevisdomAPIViewModelsSignUpRequestRoleEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsSignUpRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsSignUpRequest(value: object): value is RevisdomAPIViewModelsSignUpRequest {
    return true;
}

export function RevisdomAPIViewModelsSignUpRequestFromJSON(json: any): RevisdomAPIViewModelsSignUpRequest {
    return RevisdomAPIViewModelsSignUpRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignUpRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsSignUpRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'title': json['title'] == null ? undefined : json['title'],
        'password': json['password'] == null ? undefined : json['password'],
        'role': json['role'] == null ? undefined : json['role'],
        'notificationToEmail': json['notificationToEmail'] == null ? undefined : json['notificationToEmail'],
    };
}

export function RevisdomAPIViewModelsSignUpRequestToJSON(json: any): RevisdomAPIViewModelsSignUpRequest {
    return RevisdomAPIViewModelsSignUpRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignUpRequestToJSONTyped(value?: RevisdomAPIViewModelsSignUpRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'title': value['title'],
        'password': value['password'],
        'role': value['role'],
        'notificationToEmail': value['notificationToEmail'],
    };
}

